import React from 'react';

export const ServicePortalLogo = () => {
    return (
        <div className='sp-logo'></div>
    )
}